import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { UserContext } from "../context/UserContext"
import useSession from "../hooks/useSession"
import authAPI from "../services/auth"
import magicLinkAPI from '../services/magicLink'
import projectAPI from '../services/project'

const MagicLinkAuth = () => {
    const { code } = useParams()
    const [error, setError] = useState([])
    const [session, setSession] = useSession()
    const { user, setAuthUser, getCustomItem, addCustomItem } = useContext(UserContext)
    const navigate = useNavigate();

    const getUserData = async (jwt) => {
        const res = await authAPI.get({ jwt })
        if(res.data.data.email) setAuthUser(res.data.data)
        linkType(res.data.data, jwt)
    }

    const linkType = async (data, token) => {
        switch (data.view.scope) {
            case 'form':
                return navigate('/widget#project')
            case 'dashboard':
                return navigate('/widget#dashboard')
            case 'project':
                const project = await projectAPI.form({ jwt: token, idProject: data.view.hash_id_project })
                const hashCompletedForm = project.data.data.hash_id_widget_completed_form
                return navigate(`/widget#project/posted/${hashCompletedForm}`)
            case 'link':
                let currentUser = user;
                if (!currentUser) {
                    currentUser = JSON.parse(getCustomItem('bunny.User'))
                }

                if (currentUser) {
                    try {
                        const params = {
                            magic_link: code,
                            email: currentUser.email
                        }
                        const project = await projectAPI.magiclink({jwt: token, params})
                        const newMagicLink = project.data.data.magic_link_project
                        navigate('/invitation/' + newMagicLink)
                        navigate(0)
                    } catch (error) {
                        navigate('/unavailable')
                    }
                } else {
                    addCustomItem('bunny.MagicLink', code)
                    navigate('/guest')
                }
                break
            default:
                return navigate('/login')
        }
    }

    useEffect(() => {
        (async () => {
            setError([]);
            try {
                const res = await magicLinkAPI.auth(code)
                setSession(res.data.data.token);
                await getUserData(res.data.data.token)
            } catch (err) {
                navigate('/unavailable')
                // setError(err.response.data.errors.map(e => <p>{e.msg}</p>))
            }
        })()
    }, [])

    return (<></>)
}

export default MagicLinkAuth